import axios from "axios";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import api from "../api/api";
import constants from "../common/constants";
import { clearUser, updateToken } from "../redux/features/user/userSlice";
import { resetAppHost } from "../redux/features/app/appSlice";
var URL_PARAM_REPORT = "reportid";

//CUSTOM HOOK
const useLogout = () => {
  const [loading, setLoading] = useState(undefined);
  const user = useSelector((state) => state.user);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const handleLogout = async (errorType = "") => {
    // Call Logout Endpoint to invalidate Old JWT Token. Do not handle 410 as new session is formed.
    if (errorType != constants.logout_error_state_410) {
      await axios_Logout();
    }
    // Retrieve IncidentIdentifier if user wants to access it directly
    var incidentId = searchParams.get(URL_PARAM_REPORT) ?? "";

    // Clear User Details
    if (user.token !== "") {
      dispatch(updateToken(""));
      dispatch(resetAppHost());
    }
    navigate(constants.prefix_url + "login?ref=logout", {
      state: {
        source: constants.logout_channel,
        errortype: errorType ?? "",
        displayerror: errorType != "",
        incidentId: incidentId,
      },
    });
    return;
  };
  /// Function to execute Logout Endpoint
  const axios_Logout = async () => {
    const jwtConfig = {
      headers: {
        Authorization: `Bearer ${user.token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    };
    try {
      await axios.get(api.logoutUser, jwtConfig).finally(() => {
        setLoading(false);
      });
    } catch (ex) {}
  };

  return { loading, handleLogout };
};

export default useLogout;
